import React from "react";
import { Card } from "react-bootstrap";

const FlashSaleComponent = () => {
  return (
    <>
      <h5>Flash Sales !!</h5>
      <Card>
        <div className="row" style={{ padding: 5 }}>
          <div className="col-sm-2">
            <img
              width="80"
              height="100"
              //   style={{ padding: 1 }}
              src="https://images.pexels.com/photos/994605/pexels-photo-994605.jpeg?cs=srgb&dl=pexels-fabian-wiktor-994605.jpg&fm=jpg"
            ></img>
          </div>
          <div className="col-sm-9">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "flex-start",
                marginLeft: 21,
              }}
            >
              <label style={{ whiteSpace: "pre-line" }}>
                {
                  "Affordable Experience in Kerala \n ₹ 10350 Per Pax | 5 Nights \n"
                }
              </label>
              <div className="row">
                <div className="col-sm-6">
                  <div
                    style={{
                      color: "black",
                      //   width: "80%",
                      height: "80%",
                      fontSize: "10px",
                      backgroundColor: "#777777",

                      borderRadius: "5px",
                    }}
                  >
                    <label
                      style={{
                        padding: 5,
                        color: "white",
                        fontSize: "9px",
                      }}
                    >
                      <b>
                        Discount upto{" "}
                        <span style={{ color: "#FCCD1D" }}>₹ 2000</span>
                      </b>
                    </label>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div
                    style={{
                      color: "black",
                      //   width: "80%",
                      height: "80%",
                      fontSize: "10px",
                      backgroundColor: "#777777",

                      borderRadius: "5px",
                    }}
                  >
                    <label
                      style={{
                        padding: 5,
                        color: "white",
                        fontSize: "9px",
                      }}
                    >
                      <b>
                        TravCash upto
                        <span style={{ color: "#FCCD1D" }}> ₹ 2000</span>
                      </b>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ padding: 5 }}>
          <div className="col-sm-2">
            <img
              width="80"
              height="100"
              //   style={{ padding: 1 }}
              src="https://images.pexels.com/photos/2674064/pexels-photo-2674064.jpeg?cs=srgb&dl=pexels-stijn-dijkstra-2674064.jpg&fm=jpg"
            ></img>
          </div>
          <div className="col-sm-9">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "flex-start",
                marginLeft: 21,
              }}
            >
              <label style={{ whiteSpace: "pre-line" }}>
                {
                  "Affordable Experience in Kerala \n ₹ 10350 Per Pax | 5 Nights \n"
                }
              </label>
              <div className="row">
                <div className="col-sm-6">
                  <div
                    style={{
                      color: "black",
                      //   width: "80%",
                      height: "80%",
                      fontSize: "10px",
                      backgroundColor: "#777777",

                      borderRadius: "5px",
                    }}
                  >
                    <label
                      style={{
                        padding: 5,
                        color: "white",
                        fontSize: "9px",
                      }}
                    >
                      <b>
                        Discount upto{" "}
                        <span style={{ color: "#FCCD1D" }}>₹ 2000</span>
                      </b>
                    </label>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div
                    style={{
                      color: "black",
                      //   width: "80%",
                      height: "80%",
                      fontSize: "10px",
                      backgroundColor: "#777777",

                      borderRadius: "5px",
                    }}
                  >
                    <label
                      style={{
                        padding: 5,
                        color: "white",
                        fontSize: "9px",
                      }}
                    >
                      <b>
                        TravCash upto
                        <span style={{ color: "#FCCD1D" }}> ₹ 2000</span>
                      </b>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default FlashSaleComponent;
